import { createRoute, Outlet } from "@tanstack/react-router";
import { CustomBriefingsPage } from "pages/app/CustomBriefingsPage";
import { IndustryReportsPage } from "pages/app/IndustryReportsPage";
import { PrintReportPage } from "pages/app/PrintReportPage";
import { ReportPage } from "pages/app/ReportPage";

import { rootRoute } from "../rootRoute";

export const reportsLayoutRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: "/reports",
  staticData: { pageName: "" },
  component: Outlet,
});

export const customBriefingsRoute = createRoute({
  getParentRoute: () => reportsLayoutRoute,
  path: "/custom",
  staticData: { pageName: "Custom Briefings" },
  component: CustomBriefingsPage,
});

export const industryReportsRoute = createRoute({
  getParentRoute: () => reportsLayoutRoute,
  path: "/industry",
  staticData: { pageName: "Industry Reports" },
  component: IndustryReportsPage,
});

export const reportIdLayoutRoute = createRoute({
  getParentRoute: () => reportsLayoutRoute,
  path: "/$reportId",
  staticData: { pageName: "", breadcrumbLabel: "Report" },
  component: Outlet,
});

export const reportDetailRoute = createRoute({
  getParentRoute: () => reportIdLayoutRoute,
  path: "/",
  staticData: { pageName: "Report" },
  component: function ReportDetailRouteComp() {
    const { reportId } = reportDetailRoute.useParams();
    return <ReportPage reportId={reportId} />;
  },
});

export const printReportRoute = createRoute({
  getParentRoute: () => reportIdLayoutRoute,
  path: "/print",
  staticData: { pageName: "Print Report", noShell: true },
  // pdfToken is a short-lived signed token the PDF export flow appends so the
  // headless browser can render a private report's print page without a session.
  validateSearch: (search: Record<string, unknown>): { pdfToken?: string } => ({
    pdfToken: typeof search.pdfToken === "string" ? search.pdfToken : undefined,
  }),
  component: function PrintReportRouteComp() {
    const { reportId } = printReportRoute.useParams();
    const { pdfToken } = printReportRoute.useSearch();
    return <PrintReportPage reportId={reportId} pdfToken={pdfToken} />;
  },
});

export const reportsRouteTree = reportsLayoutRoute.addChildren([
  customBriefingsRoute,
  industryReportsRoute,
  reportIdLayoutRoute.addChildren([reportDetailRoute, printReportRoute]),
]);
